// src/app/MoodContext.js
import React, { createContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_MOOD, suggestMoodByPath } from "../theme/moods";

export const MoodContext = createContext(null);

const KEY = "moodOverride"; // "sei" | "wa" | "dou" | ""(解除)

export function MoodProvider({ children }) {
  const location = useLocation();

  const [override, setOverride] = useState(() => {
    try {
      return localStorage.getItem(KEY) || "";
    } catch {
      return "";
    }
  });

  useEffect(() => {
    try {
      if (!override) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, override);
    } catch {}
  }, [override]);

  const suggested = useMemo(
    () => suggestMoodByPath(location.pathname),
    [location.pathname]
  );

  const mood = override || suggested || DEFAULT_MOOD;

  const value = useMemo(
    () => ({
      mood, // 実際に適用されてる
      suggested, // ページが提案
      override, // ユーザー上書き
      setOverride, // "" にすると解除
    }),
    [mood, suggested, override]
  );

  return <MoodContext.Provider value={value}>{children}</MoodContext.Provider>;
}
